import { deserialize } from './serialization'

const defaultErrorHandler = (data) => data

export const handleAPIError = (error, errorHandler = defaultErrorHandler) => {
  if (error.response) {
    if (error.response.data?.errors) {
      return errorHandler(deserialize({ ...error.response.data.errors, status: error.response.status }))
    } else {
      return errorHandler({ status: error.response.status, statusText: error.response.statusText })
    }
  } else {
    return errorHandler({ general: error.message })
  }
}
